import { View } from "ol";

const en = {
  brand: "Gravity",
  home: "Home",
  link: "Link",
  dropdown: "Dropdown",
  action: "Action",
  anotherAction: "Another action",
  somethingElse: "Something else here",
  disabled: "Disabled",

  // topNav النصوص الخاصة بالـ 
  callback: "Callback",
  hideOverlay: "Hide Overlay",
  showOverlay: "Show Overlay",
  showRadius: "Show Radius",
  hideRadius: "Hide Radius",
  lang: "AR",
  changeLang: "Change Language",
  filter: "Filter",

  // النصوص الخاصة بالـ sideNav
  mapFilter: "Map Filter",
  showAll: "Show All",
  landmarks: "Landmarks",
  roads: "Roads",
  developers: "Developers",

  // النصوص الخاصة بالـ dropdown ف ال topNav
  jeddahPage: "Jeddah",
  gravityPage: "Gravity",
  ExploreTour: "Explore Tour",

  // form
  title_form: "Request Callback",
  firstName: "First Name",
  lastName: "Last Name",
  email: "Email",
  phone: "Phone",
  residence: "Residence",
  nationality: "Nationality",
  message: "Message",
  send: "Send",
  loading: "Sending...",


  // statistics
  totalLandArea: "Total land area",
  totalResidence: "Total residence",
  landscape: "Landscape",
  totalResiUnits: "Total resi units",
  projectBUA: "Project BUA",

  // notes
  captionNotes: "If you continue to use this site, you agree to the terms and conditions.",
  ViewFull: "View Full Terms and Conditions ",
  DescriptionNotes1: `Thabat Al-Maskan Real Estate Company hereby declares that the
              virtual tour, including the amenities shown in the properties,
              does not constitute part of any offer or contract for sale or
              purchase.`,
  DescriptionNotes2: ` This plan is for use only to provide a general impression of the
              project's master plan, including finishing materials, the
              approximate location of amenities and services, and an estimate of
              distances to nearby amenities. It is not intended for any other
              use.`,
  DescriptionNotes3: ` The interiors shown in the residential units and the images
              included in the virtual tour are for illustrative purposes only.
              The proposed unit images, including furniture, fixtures,
              electronic equipment, merchandise, amenities, landscaping, and
              accessories, such as color schemes, are intended only to provide a
              general idea of the residential character of the units.`,
  DescriptionNotes4: ` Thabat Al-Maskan Real Estate does not guarantee the accuracy or
              stability of the future development shown, or the availability of
              current or future amenities and services, or their location. All
              details provided are subject to change based on future
              circumstances.`,
  DescriptionNotes5: ` All distances and sizes are approximate and for guidance purposes
              only, and are not to scale. Any estimates of distances or travel
              times are indicative and not final.`,
  btnNotes: "Agree",









  // masterplan
  // masterplan => filter 
  search: "Search",
  reset: "Reset",
  min: "Min",
  max: "Max",
  to: "To",
  bedrooms: "Bedrooms",
  bathrooms: "Bathrooms",
  area: "Area (Sq.m.)",
  showResult: "Show Result",
  // showSideMenu
  showed: "Showed",
  of: "of",
  showMore: "Show More",


};

export default en;
